import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { timeOffService } from '../api/time-off.service';
import { TIME_OFF_KEYS } from './queryKeys';
import type { TimeOffDateRangeQueryParams } from '../types';

/** Scoped by visibility server-side, not role — any member can call this. Plain array. */
export function useTeamTimeOffAbsences(params: TimeOffDateRangeQueryParams) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useQuery({
    queryKey: TIME_OFF_KEYS.team(orgId, params),
    queryFn: ({ signal }) => timeOffService.getTeamAbsences(params, signal),
    staleTime: 60_000,
    enabled: !!orgId && !!params.from && !!params.to,
  });
}
